import axios from 'axios';
import { ManualFeed } from '../types/manual-feed.type';
import { UpdateManualFeedInput } from '../types/update-manual-feed-input.type';

// PUT
// Update feed.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}/feed/{feedId}
export const putManualFeed = async (globalCompanyId: string, feedId: string, request: UpdateManualFeedInput): Promise<ManualFeed> => {
  const res = await axios.put<ManualFeed>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/feed/${feedId}`, request);
  return res.data;
};
